module.exports = __webpack_public_path__ + "assets/img/4a517212e12fa956e268014aefbe0294.svg";